// Matomo events for the promo funnel:
//   Game/ExamStarted → Game/ExamPassed → Promo/CtaShown → Promo/CtaClicked
// plus dojo picks and shares. No-ops when the tracker isn't loaded (tests,
// dev, blocked by the browser). No personal data is sent — only game facts.

type Paq = { push: (args: unknown[]) => void };

function paq(): Paq | null {
  const w = window as unknown as { _paq?: Paq };
  return w._paq ?? null;
}

export function track(category: string, action: string, name?: string, value?: number): void {
  const args: unknown[] = ['trackEvent', category, action];
  // Keep the slots: a value without a name still goes in the value slot
  if (name !== undefined || value !== undefined) args.push(name);
  if (value !== undefined) args.push(Math.round(value));
  paq()?.push(args);
}
